var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';

var Phased = function (_super) {
  __extends(Phased, _super);

  function Phased() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      lastValue: _this.props.value,
      value: _this.props.value,
      nextValue: _this.props.value,
      phase: 0,
      phasing: false
    };
    _this.tm = 0;

    _this.shift = function () {
      return _this.props.onShift && _this.props.onShift(_this.state);
    };

    return _this;
  }

  Phased.prototype.componentDidUpdate = function (prevProps, oldState) {
    var _this = this;

    var _a = this.props,
        value = _a.value,
        _b = _a.phases,
        phases = _b === void 0 ? 0 : _b;

    if (prevProps.value !== value) {
      this.shift();
      this.setState({
        lastValue: prevProps.value,
        nextValue: this.props.value,
        phase: 0,
        phasing: true
      });
    } else {
      if (this.state !== oldState) {
        this.shift();
        clearTimeout(this.tm);
        this.tm = window.setTimeout(function () {
          if (_this.state.phase < phases) {
            _this.setState(function (_a) {
              var phase = _a.phase;
              return {
                phase: phase + 1
              };
            });
          } else {
            if (_this.state.value !== value) {
              _this.setState(function (_a) {
                var phase = _a.phase;
                return {
                  phase: phase + 1,
                  value: value
                };
              });
            } else {
              if (_this.state.phasing) {
                _this.setState({
                  phasing: false
                });
              }
            }
          }
        }, (this.props.timeouts || [])[this.state.phase] || 0);
      }
    }
  };

  Phased.prototype.render = function () {
    return this.props.children(this.state);
  };

  return Phased;
}(React.Component);

export { Phased };